import _wxapi from "./api";
// 加载wx.js
_wxapi.loadWxApi();
export function checkWx(arr = []) {
  // return new Promise((resolve, reject) => {
  let jsApiList = [
    "hideOptionMenu", //隐藏右上角菜单接口
    "showOptionMenu", //显示右上角菜单接口
    "closeWindow", //关闭当前网页窗口接口
    "hideAllNonBaseMenuItem", //隐藏所有非基础按钮接口
    "showAllNonBaseMenuItem", //显示所有功能按钮接口
    "hideMenuItems", //批量隐藏功能按钮接口
    "showMenuItems", //批量显示功能按钮接口
    "scanQRCode", //政务微信扫一扫
    "openLocation", //使用政务微信内置地图查看位置接口
    "getLocation", //获取地理位置接口
    "openUserProfile", // 获取个人信息 此接口在政务微信1.5.0及以后版本支持，外部
    "openUrl",
    "shareAppMessage", // 分享到会话接口. 1,6以上支持
    "onMenuShareAppMessage", // 分享
    "onMenuShareWechat", //获取“微信”按钮点击状态及自定义分享内容接口
    "showWatermark",
    "openEnterpriseChat", //创建会话接口
    "selectEnterpriseContact", //通讯录选人接口
    "launch3rdApp", // 唤起第三方app
    "request3rdApp", // 唤起第三方app并交互登录信息
    "getInstallState", //获取app版本信息
    "openEnterpriseApp", //打开单位应用
    "openChatWithMsg", // 创建会话并发送消息
  ];

  if (arr.length) {
    jsApiList = arr.concat(jsApiList);
  }
  //  检测版本号
  if (_wxapi.check_ver()) {
    if (!window["wx"]) {
      _wxapi.loadWxApi(function () {
        console.log("加载wx");
        _wxapi.initConfig({
          jsApiList,
          sucesscb: function () {},
          errorcb: function () {},
        });
      });
    } else if (window["wx"]) {
      console.log("加载了JS，但没初始化");
      // 加载了JS，但没初始化
      _wxapi.initConfig({
        jsApiList,
        sucesscb: function () {},
        errorcb: function () {},
      });
    }
  } else {
    // reject(new Error("版本过低"));
    console.log("版本过低");
  }
  // });
}
